module.exports = __webpack_public_path__ + "media/images/android-icon-192x192-dbf75c65.png";